import { LocalOfferOutlined } from '@mui/icons-material'
import { Box, Button, Container, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'
import React from 'react'

export interface ClevertapTextBannerProps {
    title: string
    subTitle: string
    viewDetailsLabel: string
    showViewDetails: boolean
    onViewDetails: () => void
}

/**
 * Presentation for the CleverTap web-native-display (KV) home banner.
 *
 */
const ClevertapTextBanner: React.FC<ClevertapTextBannerProps> = ({
    title,
    subTitle,
    viewDetailsLabel,
    showViewDetails,
    onViewDetails
}) => (
    <Container maxWidth="xl" sx={{ px: { xs: 2 } }}>
        <Box
            sx={{
                position: 'relative',
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                alignItems: { xs: 'stretch', md: 'center' },
                gap: 1.5,
                p: 2,
                mb: 2,
                bgcolor: 'common.white',
                border: '1px solid',
                borderColor: 'grey.300',
                borderRadius: '18px',
                boxShadow: '0 4px 16px rgba(15, 23, 42, 0.08)',
            }}
        >
            {/* Icon + text */}
            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: subTitle ? 1 : 0 }}>
                    <Box
                        sx={{
                            width: 36,
                            height: 36,
                            flexShrink: 0,
                            borderRadius: 1.5,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1)
                        }}
                    >
                        <LocalOfferOutlined sx={{ color: 'primary.main', fontSize: 18 }} />
                    </Box>

                    {title && (
                        <Typography
                            sx={{ fontWeight: 700, fontSize: { xs: 14, md: 16 }, color: 'text.primary', lineHeight: 1.3 }}
                        >
                            {title}
                        </Typography>
                    )}
                </Box>

                {subTitle && (
                    <Typography sx={{ fontSize: { xs: 12, md: 14 }, color: 'text.secondary', lineHeight: 1.5 }}>
                        {subTitle}
                    </Typography>
                )}
            </Box>

            {/* Action — right-aligned on both layouts (bottom-right when stacked) */}
            {showViewDetails && (
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: { xs: 1.5, md: 0 } }}>
                    <Button
                        variant="contained"
                        size="small"
                        onClick={onViewDetails}
                        sx={{
                            flexShrink: 0,
                            borderRadius: 1.5,
                            textTransform: 'none',
                            whiteSpace: 'nowrap',
                            py: 1,
                            px: 2.5,
                            fontWeight: 700,
                            fontSize: { xs: 12, md: 14 }
                        }}
                    >
                        {viewDetailsLabel}
                    </Button>
                </Box>
            )}
        </Box>
    </Container>
)

export { ClevertapTextBanner }
export default ClevertapTextBanner
